import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const DraftApplicationList = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editDraftApplications.role,
    permissionsConfig.editDraftApplications.action,
    permissionsConfig.editDraftApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteDraftApplications.role,
    permissionsConfig.deleteDraftApplications.action,
    permissionsConfig.deleteDraftApplications.type
  );

  return (
    <StatusApplication appStatus="3" title="Draft/Payment Due" subTitle="Draft/Payment Due" application_type="" pageFrom="draft-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default DraftApplicationList;
